import React from 'react'

const NavigationDots = ({active}) => {
  return (
    <div className='app__navigation   '>
      
      {["home", "about", "contact", "work", "skills","testimonials", "contact"].map(
          (item,index) => (
            <li className="app__flex p-text" key={`link-${item}`}>
              <div />
              <a href={`#${item}`}
              key={item+index}
              className="app__navigation-dot"
              style={active===item?{backgroundColor:'#313BAC'}:{}}
              ></a>
            </li>
          )
        )}


    </div>
  )
}

export default NavigationDots
